import { useEffect, useRef } from 'react';
import { simulateMouseClick } from 'tools/tools';

interface UseGridLifecycleProps {
    isLoading: boolean;
    columns: any[];
    gridData: any[];
    filtered: boolean;
    gridDataChanged: boolean;
    setGridDataChanged: (changed: boolean) => void;
    setReadyToDraw: (ready: boolean) => void;
    showEditSelector: string;
    setShowEditSelector: (selector: string) => void;
    reloadTrigger?: number;
    reloadGridData?: () => Promise<void> | void;
    formGrid?: boolean;
    onDataStoreChange?: (data: any[], isUserAction?: boolean) => void;
}

export const useGridLifecycle = ({
    isLoading,
    columns,
    gridData,
    filtered,
    gridDataChanged,
    setGridDataChanged,
    setReadyToDraw,
    showEditSelector,
    setShowEditSelector,
    reloadTrigger,
    reloadGridData,
    formGrid,
    onDataStoreChange,
}: UseGridLifecycleProps) => {
    const prevGridDataRef = useRef<any[]>([]);

    useEffect(() => {
        if (!isLoading && columns.length > 0 && formGrid && onDataStoreChange) {
            const dataChanged = JSON.stringify(prevGridDataRef.current) !== JSON.stringify(gridData);

            if ((!filtered || gridDataChanged) && dataChanged) {
                onDataStoreChange(gridData, gridDataChanged);
                prevGridDataRef.current = gridData;
                setGridDataChanged(false);
            }

            if (gridData.length === 0 && prevGridDataRef.current.length !== 0) {
                prevGridDataRef.current = gridData;
                setReadyToDraw(true);
            }
        }
    }, [
        gridData,
        isLoading,
        columns.length,
        formGrid,
        onDataStoreChange,
        filtered,
        gridDataChanged,
        setGridDataChanged,
        setReadyToDraw,
    ]);

    useEffect(() => {
        if (!isLoading && showEditSelector > '') {
            setTimeout(() => {
                const element = document.querySelector(showEditSelector);
                setShowEditSelector('');
                simulateMouseClick(element);
            }, 200);
        }
    }, [isLoading, showEditSelector, setShowEditSelector]);

    useEffect(() => {
        if (reloadTrigger && reloadTrigger > 0 && reloadGridData) {
            reloadGridData();
        }
    }, [reloadTrigger, reloadGridData]);
};
